import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { m as d } from "motion/react";
import { useAnimateFadeIn as r } from "../../../animation/animation.js";
import { Heading as c } from "../../elements/heading/heading.js";
import a from "./text-block.module.less.js";
const f = ({ title: t, preamble: i, text: s }) => {
  const m = r({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ e("section", { className: a.section, children: /* @__PURE__ */ n(d.div, { ...m, className: "max-width padded-sides centered", children: [
    /* @__PURE__ */ e(c, { semanticType: "h2", visualType: "h3", className: "heading-max-width", children: t }),
    i && /* @__PURE__ */ e("p", { className: `${a.preamble} preamble text-max-width`, children: i }),
    /* @__PURE__ */ e("div", { className: "text-max-width", children: s })
  ] }) });
};
export {
  f as TextBlock,
  f as default
};
